import GenerateRequest from './resources';
import { checkLicenseExpiry } from './ResourceValidations';

const req = GenerateRequest();

export default {
  async getAllCompanyIds(params = {}) {
    try {
      const companyIds = await req.get('sqlcreds/getAllCompanyIds', params);
      return companyIds;
    } catch (e) {
      throw e.response;
    }
  },
  async getSqlCredForCompany(id) {
    try {
      await checkLicenseExpiry();
      return (await req.get('sqlcreds/getSqlCredForCompany', { params: { id } })).data;
    } catch (e) {
      throw e.response;
    }
  },
  // This API takes the following parameters:
  // {
  //   id: string (required) - company id for which sql creds are to be fetched
  // }
  async getSqlCreds(id) {
    try {
      await checkLicenseExpiry();
      return (await req.get(`sqlcreds/get/${id}`)).data;
    } catch (e) {
      throw e.response;
    } 
  },
};
